/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
import Cart from 'cart-store';

// Listen for your custom refresh event
document.addEventListener("cart:kai-refresh-custom", async (e) => {
  console.log("Manual cart refresh triggered", e?.detail);
  try {
    await Cart.refresh();
    console.log("Cart refreshed successfully!");
  } catch (err) {
    console.error("Cart refresh failed", err);
  }
});